<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <v-chip color="grey-lighten-1" variant="outlined" class="ml-3" v-bind="props" label v-if="numberOfSchematisation"
              size="x-small">
        <template #prepend>
          <v-icon class="mr-2">mdi-image-filter-hdr</v-icon>
        </template>
        <div style="color:black">

          {{ numberOfSchematisation }}
        </div>
      </v-chip>
    </template>
    <span>There are {{ numberOfSchematisation }} schematisations available
        </span>
  </v-tooltip>
</template>
<script>
  export default {
    name: "NumberOfSchematisationChip",
    props: {
      numberOfSchematisation: {}
    }
  }
</script>